// @ts-nocheck

import {t} from "i18next";

import {
  formSkuTableAmount,
  formSkuTablePriceString,
  formSkuTableSpecPriceString,
  formSkuTableTotalSumString,
} from "../../Components/KP/kp-f/utils/functions";
import {COLOR_SCHEME} from "../colorSheme";
import {IMAGE_TYPE_SKU_PLAN} from "../generalConstants.js/generalConstants";
import makeNameFromPersona from "../makeNameFromPersona";
import {numberFormat} from "../moneyFormat";

export default class SKU_PLAN_ASSET {
  constructor(skuPlan = {}, language = "en", measureQuantities = {}) {
    this.skuPlan = skuPlan;
    this.language = language;
    this.totalInObject = +skuPlan?.totalInObject;
    this.measurementQuantities = measureQuantities;

    // Object.assign(this, skuPlan);

    //количество юнитов (м2...)
    this.quantity = +skuPlan?.quantity ?? +skuPlan?.sku?.quantity;

    //количество типов продажи (упаковок...)
    this.amount = +skuPlan?.amount;

    //цена за юнит (м2...)
    this.averageSalesPrice = +skuPlan?.skuPlanPrice?.averageSalesPrice;
    this.catalogPrice = +skuPlan?.skuPlanPrice?.catalogPrice;
    this.minPrice = +skuPlan?.sku?.skuPrices?.[0]?.minPrice;
    this.maxPrice = +skuPlan?.sku?.skuPrices?.[0]?.maxPrice;

    this.measurementUnit = skuPlan?.sku?.measurementUnit || skuPlan?.measurementUnit;
    this.measurementObject = skuPlan?.sku?.measurementObject || skuPlan?.measurementObject;
    this.discountCheck = skuPlan?.currentSkuPlan
      ? skuPlan?.currentSkuPlan?.skuPlanPrice?.discountCheck
      : skuPlan?.skuPlanPrice?.discountCheck;

    //спец скидка в %
    this.discount = +skuPlan?.skuPlanPrice?.discount;
    this.discountPrice = (this.averageSalesPrice * 100 * (1 - +skuPlan?.skuPlanPrice?.discount / 100)) / 100;

    //скидка на фабрику в %
    this.additionalDiscount = +skuPlan?.skuPlanPrice?.additionalDiscount;

    //Индивидуальная (общая) скидка
    this.topDiscount = +skuPlan?.skuPlanPrice?.topDiscount;
    this.topDiscountCheck = skuPlan?.skuPlanPrice?.topDiscountCheck;

    this.finishPrice = +skuPlan?.skuPlanPrice?.finishPrice;

    //characteristics
    this.charCheck = !!skuPlan?.charCheck;
    this.characteristicsText =
      skuPlan?.characteristicsText ||
      `${
        skuPlan?.material
          ? `${t("Finishing")}: ${
              skuPlan.material?.[language === "en" ? "engName" : "name"]?.trim() || skuPlan.material
            },\n`
          : skuPlan?.materialType
          ? `${skuPlan.materialType},\n`
          : ""
      }${skuPlan?.color ? `${t("Color")}: ${skuPlan.color}` : ""}`;
    this.characteristicsTextEng =
      skuPlan?.characteristicsTextEng ||
      `${
        skuPlan?.material
          ? `${"Finishing"}: ${
              skuPlan.material?.[language === "en" ? "engName" : "name"]?.trim() || skuPlan.material
            },\n`
          : skuPlan?.materialType
          ? `${skuPlan.materialType},\n`
          : ""
      }${skuPlan?.color ? `${"Color"}: ${skuPlan.color}` : ""}` ||
      skuPlan?.characteristicsText;
    this.color = skuPlan?.color;
    this.material = skuPlan?.material;
    this.batch = skuPlan?.batch;
    this.batchCheck = skuPlan?.batchCheck;
    this.productSeries = skuPlan?.productSeries;
    this.productSeriesCheck = skuPlan?.productSeriesCheck;
    this.article = skuPlan?.articleColor ? `${skuPlan?.article}.${skuPlan?.articleColor}` : skuPlan?.article;
    this.overallSizeCheck = skuPlan?.overallSizeCheck;
    this.overallSizeUnit = skuPlan?.overallSizeUnit;
    this.width = skuPlan?.width;
    this.length = skuPlan?.length;
    this.height = skuPlan?.height;
    this.areaCheck = skuPlan?.areaCheck;
    this.areaUnit = skuPlan?.areaUnit;
    this.area = skuPlan?.area;
    this.weightCheck = skuPlan?.weightCheck;
    this.weightUnit = skuPlan?.weightUnit;
    this.weight = skuPlan?.weight;
    this.volumeCheck = skuPlan?.volumeCheck;
    this.volumeUnit = skuPlan?.volumeUnit;
    this.volume = skuPlan?.volume;
    this.palletCheck = skuPlan?.palletCheck;
    this.pallet = skuPlan?.pallet;

    this.factoryName = skuPlan?.factory?.name;
    this.skuName = language === "en" ? skuPlan?.nameEng || skuPlan?.name : skuPlan?.name || skuPlan?.nameEng;
    this.complectDesc = skuPlan?.complectDescCheck && skuPlan?.complectDesc ? skuPlan?.complectDesc : "";

    this.addedImages = (skuPlan?.images || []).map(item => item.imagePlan || item).filter(item => item.isUsed);

    this.orderNumber = skuPlan?.order?.orderNumber;
    this.managerCo = makeNameFromPersona({persona: skuPlan?.order?.co?.managerCo?.persona, language: this.language});
    this.productGroupName = skuPlan?.productGroup?.name;
    this.productTypeName = skuPlan?.productType?.[language === "en" ? "nameEng" : "name"];
  }

  get articleWithoutBrandPrefix() {
    return this.article?.split("-")?.[1];
  }
  get articleName() {
    if (!this.article) {
      return "";
    }

    const dashIndex = this.article.indexOf("-");
    const dotIndex = this.article.lastIndexOf(".");

    return dotIndex === -1 ? this.article.slice(dashIndex + 1) : this.article.slice(dashIndex + 1, dotIndex);
  }

  get articleColor() {
    if (!this.article) {
      return "";
    }

    const dotIndex = this.article.indexOf(".");

    return dotIndex === -1 ? "" : this.article.slice(dotIndex + 1);
  }

  //количество юнитов в типе продаже (м2 в рулоне, изделий в упаковке и т.д.)
  get quantityPerSaleObject() {
    return this.totalInObject * this.quantity;
  }

  //общее количество юнитов в добавляемом плановом СКЮ
  get totalQuantity() {
    return this.quantityPerSaleObject * this.amount;
  }

  get isAmountFractional() {
    return this.amount % 1 > 0;
  }

  //цена за тип продажи (упаковку, рулон и т.д.)
  get pricePerSaleObject() {
    return this.quantityPerSaleObject * this.averageSalesPrice;
  }

  //общяя цена в добавляемом плановом СКЮ до скидок (спец. цена, скидка на фабрику, индувид скидка)
  get totalPrice() {
    return this.averageSalesPrice * this.totalQuantity;
  }

  //Спец цена за тип продажи
  get specialPricePerObject() {
    if (!this.hasDiscount) return "";
    return this.discountCheck && this.discount
      ? this.discountPrice * this.quantityPerSaleObject
      : this.additionalDiscount
      ? (this.pricePerSaleObject * 100 * ((100 - this.additionalDiscount) / 100)) / 100
      : "";
  }

  get totalSpecPrice() {
    if (this.discountPrice === this.averageSalesPrice) return this.totalPrice;
    return this.discountCheck && this.discountPrice && this.totalQuantity
      ? this.discountPrice * this.totalQuantity
      : "";
  }

  get finalPricePerObject() {
    const basePrice = this.hasDiscount ? this.specialPricePerObject : this.pricePerSaleObject;
    return this.topDiscount ? (basePrice * 100 * ((100 - this.topDiscount) / 100)) / 100 : "";
  }

  get paymentSum() {
    const basePrice = this.topDiscount
      ? this.finalPricePerObject
      : this.hasDiscount
      ? this.specialPricePerObject
      : this.pricePerSaleObject;

    return basePrice * this.amount;
  }

  get measurementUnitName() {
    return this.measurementUnit?.[this.language === "en" ? "engName" : "name"] || "";
  }
  get measurementObjectName() {
    return this.measurementObject?.[this.language === "en" ? "engName" : "name"] || "";
  }
  get isMeasurementObjectName() {
    return Boolean(this.measurementObjectName);
  }

  //Тип Продажи === Виріб, юнит === шт (в 1 Виробе может быть только 1шт)
  get isPieceProduct() {
    return this.measurementObject?.objectId === 1 && this.measurementUnit?.unitId === 1;
  }

  get hasDiscount() {
    return Boolean((this.discountCheck && this.discount) || this.additionalDiscount);
  }

  get saleLessThanMin() {
    return this.averageSalesPrice < this.minPrice;
  }
  get saleBiggerThanMax() {
    return this.averageSalesPrice > this.maxPrice;
  }
  get specLessThanMin() {
    return this.discountCheck && this.discount !== null && this.discountPrice < this.minPrice;
  }
  get specBiggerThanMax() {
    return this.discountCheck && this.discount !== null && this.discountPrice > this.maxPrice;
  }

  get skuPlanPricesRangeAlertBtnColor() {
    if (this.saleLessThanMin || this.saleBiggerThanMax || this.specLessThanMin || this.specBiggerThanMax) {
      return COLOR_SCHEME.ALERT;
    } else {
      return COLOR_SCHEME.BLUE;
    }
  }
  get skuPlanPricesRangeAlertBtnMessage() {
    const alerts = [];
    if (this.saleLessThanMin) {
      alerts.push(t("Sell price is less than minimum price"));
    }
    if (this.saleBiggerThanMax) {
      alerts.push(t("Sell price is higher than maximum price"));
    }
    if (this.specLessThanMin) {
      alerts.push(t("Special price is less than minimum price"));
    }
    if (this.specBiggerThanMax) {
      alerts.push(t("Special price is higher than maximum price"));
    }
    return alerts.length > 0 ? alerts.join(" | ") : t("Price in CO is within acceptable range");
  }

  get characteristics() {
    return this.formSKUCharacteristics();
  }
  get vwc() {
    return this.formVWC();
  }

  get image1() {
    return this.addedImages?.find(img => img?.imageType === IMAGE_TYPE_SKU_PLAN.IMAGE)?.imageUrl || "";
  }
  get image2() {
    return this.addedImages?.find(img => img?.imageType === IMAGE_TYPE_SKU_PLAN.DRAWING)?.imageUrl || "";
  }
  get overallImages() {
    return this.addedImages?.filter(img => img?.imageType === IMAGE_TYPE_SKU_PLAN.OVERALL) || [];
  }
  get decorImages() {
    return this.addedImages?.filter(img => img?.imageType === IMAGE_TYPE_SKU_PLAN.DECOR) || [];
  }
  get colorImages() {
    return this.addedImages?.filter(img => img?.imageType === IMAGE_TYPE_SKU_PLAN.COLOR) || [];
  }

  get skuTablePrice() {
    return formSkuTablePriceString({
      averageSalesPrice: this.averageSalesPrice,
      skuPlan: this.skuPlan,
      language: this.language,
      t,
    });
  }
  get skuTableDiscount() {
    return this.discountCheck && +this.discount
      ? numberFormat(+this.discount)
      : +this.additionalDiscount
      ? numberFormat(+this.additionalDiscount)
      : "";
  }
  get skuTableSpecPrice() {
    return formSkuTableSpecPriceString({skuPlan: this.skuPlan, language: this.language, t});
  }
  get skuTableTopDiscount() {
    return this.topDiscountCheck ? numberFormat(+this.topDiscount) : "";
  }
  get skuTableTotalSum() {
    return formSkuTableTotalSumString({skuPlan: this.skuPlan, language: this.language, t});
  }
  get skuTableAmount() {
    return formSkuTableAmount({skuPlan: this.skuPlan, language: this.language, t});
  }
  get skuTablePaymentSum() {
    return numberFormat(this.paymentSum);
  }
  get areaTableData() {
    return numberFormat(
      (this.areaCheck && this.area * (this.areaUnit?.multiplier ?? 1)) ||
        (this.width && this.length ? this.width * this.length * this.overallSizeUnit.multiplier ** 2 : " - "),
      5,
    );
  }
  get volumeTableData() {
    return numberFormat(
      (this.volumeCheck && this.volume * (this.volumeUnit?.multiplier ?? 1)) ||
        (this.width && this.length && this.height
          ? this.width * this.length * this.height * this.overallSizeUnit.multiplier ** 3
          : " - "),
      5,
    );
  }

  //установить количество типов продажи (упаковок...)
  setAmount(value) {
    this.amount = +value;
  }

  setTotalQuantity(value) {
    this.amount = +value / this.quantityPerSaleObject;
  }

  setDiscount(value) {
    this.discount = +value;
    this.discountPrice = this.calculateDiscountPrice({discount: value});
  }

  setDiscountPrice(value) {
    this.discountPrice = +value;
    this.discount = this.calculateDiscount({discountPrice: value});
  }

  setAverageSalesPrice(value) {
    this.averageSalesPrice = +value;
  }

  //рассчет реального количества юнитов под желаемое количество юнитов, учитывая тип продажи
  calcRealAmountFromWishAmount(wish) {
    this.amount = Math.ceil(wish / this.quantityPerSaleObject);
    return this.amount;
  }

  //Тип продажи
  formMeasurementObjectName({language}) {
    return this.measurementObject?.[language === "en" ? "engName" : "name"] || "";
  }

  //Юнит
  formMeasurementUnittName({language}) {
    return this.measurementUnit?.[language === "en" ? "engName" : "name"] || "";
  }

  calculateDiscountPrice({discount}) {
    return this.averageSalesPrice * (1 - +discount / 100);
  }

  calculateDiscount({discountPrice}) {
    return ((this.averageSalesPrice - +discountPrice) / this.averageSalesPrice) * 100;
  }

  formSKUCharacteristics() {
    return `${this.color ? `${t("Color")}: ${this.color}.\n` : ""}${
      this.material ? `${t("Finishing")}: ${this.material}.\n` : ""
    }${this.productSeries && this.productSeriesCheck ? `${t("Product Series")}: ${this.productSeries}.\n` : ""}${
      this.batch && this.batchCheck ? `${t("Batch")}: ${this.batch}.\n` : ""
    }`;
  }

  formVWC() {
    const ovhKeys = ["overallSizeCheck", "areaCheck", "volumeCheck", "weightCheck", "palletCheck"];

    const countOvh = (value, unit) => {
      if (value && unit) {
        const multiplier = unit.multiplier || 1;
        const result = +value * +multiplier;

        return result > 0
          ? numberFormat(result, 3) +
              " " +
              (unit?.title ? unit.title : this.language === "en" ? unit?.engName : unit?.name)
          : "";
      }
      return "";
    };

    const getOvh = type => {
      if (!this?.[type]) {
        return "";
      }

      const dimenSh = [this.length, this.width, this.height];

      switch (type) {
        case "overallSizeCheck":
          if (dimenSh.some(item => item !== null)) {
            const overallSizeUnit = this.overallSizeUnit?.[this.language === "en" ? "engName" : "name"];
            const multiplier = parseFloat(this.overallSizeUnit?.multiplier || 1);

            const updatedNumbers = dimenSh.map(num => {
              const cleaned = num === null || num === "0.00" ? 0 : parseFloat(num);
              return numberFormat(cleaned * multiplier, 3);
            });

            return `${updatedNumbers[0]}x${updatedNumbers[1]}x${updatedNumbers[2]} ${overallSizeUnit}`;
          }
          break;

        case "areaCheck":
          return countOvh(this.area, this.areaUnit);

        case "volumeCheck":
          return countOvh(this.volume, this.volumeUnit);

        case "weightCheck":
          return countOvh(this.weight, this.weightUnit);

        case "palletCheck":
          if (this.pallet) {
            return (
              [numberFormat(this.pallet.length), numberFormat(this.pallet.width)]
                .filter(e => e != null && e !== "")
                .join("×") + `(${this.pallet.name})`
            );
          }

          break;

        default:
          break;
      }
    };

    return ovhKeys
      .map(key => {
        return getOvh(key);
      })
      .filter(item => item)
      .join(", ");
  }

  formSkuArticle({prefix, article, articleColor, isForDublicate}) {
    return `${prefix}-${article}${isForDublicate ? "d" : ""}.${articleColor}`;
  }
}
